import {BBS_CATEGORY} from '../defines/protocol';
import {Txt2Date} from '../defines/common.func';


export class Article {
  no: number;
  title: string;
  thumbnail: string;
  content: string;
  brief: string;
  category: BBS_CATEGORY;
  lastModified: Date;
  registered: Date;


  constructor(obj?: any) {
    this.no                 = (obj && obj.no)                 ?? null;
    this.title              = (obj && obj.title)              ?? null;
    this.thumbnail          = (obj && obj.thumbnail)          ?? null;

    // 손전화 앱/웹에서는 content_app, brief_app는 이 존재한다면 우선적으로 사용한다.
    this.content            = (obj && obj.content_app) ?? obj.content ?? null;
    this.brief              = (obj && obj.brief_app) ?? obj.brief ?? null;

    this.category           = (obj && obj.category as BBS_CATEGORY) ?? null;
    this.lastModified       = (obj && obj.last_modified)      ? Txt2Date(obj.last_modified) : null;
    this.registered         = (obj && obj.registered)         ? Txt2Date(obj.registered) : null;
  }
}


